export default "__VITE_ASSET__I$RVTzUN__"